<ng-container *mobxAutorun>
  <div class="table-cell-container">
    <div class="table-cell-inner"><ng-content></ng-content></div>
  </div>
</ng-container>
